module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/typography/title-with-border/title-with-border.component.scss
// module id = ./src/app/features/typography/title-with-border/title-with-border.component.scss
// module chunks = main